var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectionRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 242,
    viewBox: "0 0 315 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5049 59.5255L80.1906 27.5532C124.876 -5.91685 189.111 -9.22272 237.863 19.4386L248.105 25.4601C299.128 55.4563 315.876 115.034 286.7 162.755C271.549 194.998 236.021 216 196.628 216H157.293C109.726 216 64.7387 196.828 35.024 163.892L26.9941 154.992C22.3467 149.841 18.5596 144.124 15.7493 138.016C3.05889 110.436 11.8423 78.7472 37.5049 59.5255Z",
    fill: "#E8F0FE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.5,
    cy: 226.5,
    rx: 157.5,
    ry: 15.5,
    fill: "#F3F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8384 24.77H75.5082V209.076H86.8384V24.77Z",
    fill: "url(#paint0_linear_10115_8881)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0522 175.614H72.2912V226.436H90.0522V175.614Z",
    fill: "url(#paint1_linear_10115_8881)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0522 175.614H72.2912L75.5082 173.493H86.8352L90.0522 175.614Z",
    fill: "url(#paint2_linear_10115_8881)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M86.8384 43.0811H75.5082V51.1212H86.8384V43.0811Z",
    fill: "url(#paint3_linear_10115_8881)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M72.2881 226.439H90.0491V209.079H72.2881V226.439Z",
    fill: "url(#paint4_linear_10115_8881)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.706 24.77H225.376V209.076H236.706V24.77Z",
    fill: "url(#paint5_linear_10115_8881)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92 175.614H222.159V226.436H239.92V175.614Z",
    fill: "url(#paint6_linear_10115_8881)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92 175.614H222.159L225.376 173.493H236.703L239.92 175.614Z",
    fill: "url(#paint7_linear_10115_8881)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M222.159 226.439H239.92V209.079H222.159V226.439Z",
    fill: "url(#paint8_linear_10115_8881)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M236.706 43.0811H225.376V51.1212H236.706V43.0811Z",
    fill: "url(#paint9_linear_10115_8881)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.474 126.745V25.1078C263.474 19.4804 258.888 14.9185 253.231 14.9185L58.9831 14.9185C53.3265 14.9185 48.741 19.4804 48.741 25.1078V126.745C48.741 132.372 53.3265 136.934 58.9831 136.934H253.231C258.888 136.934 263.474 132.372 263.474 126.745Z",
    fill: "#7F0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.285 15.7505H58.9265C53.7614 15.7505 49.5743 19.916 49.5743 25.0545V126.798C49.5743 131.936 53.7614 136.102 58.9265 136.102H253.285C258.45 136.102 262.637 131.936 262.637 126.798V25.0545C262.637 19.916 258.45 15.7505 253.285 15.7505Z",
    fill: "#C00000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M252.398 20.7344C253.784 20.7344 255.114 21.2822 256.094 22.2573C257.074 23.2324 257.625 24.5549 257.625 25.9339V125.916C257.625 126.599 257.489 127.275 257.227 127.906C256.964 128.536 256.579 129.11 256.094 129.592C255.609 130.075 255.032 130.458 254.398 130.72C253.764 130.981 253.085 131.115 252.398 131.115H59.8101C58.424 131.115 57.0947 130.568 56.1145 129.592C55.1344 128.617 54.5837 127.295 54.5837 125.916V25.9339C54.5837 24.5549 55.1344 23.2324 56.1145 22.2573C57.0947 21.2822 58.424 20.7344 59.8101 20.7344H252.398ZM252.398 19.4048H59.8101C58.0701 19.4064 56.4017 20.0949 55.1713 21.3189C53.9409 22.543 53.2489 24.2027 53.2473 25.9339V125.916C53.2489 127.647 53.9409 129.307 55.1713 130.531C56.4017 131.755 58.0701 132.443 59.8101 132.445H252.398C254.138 132.443 255.807 131.755 257.037 130.531C258.267 129.307 258.959 127.647 258.961 125.916V25.9339C258.959 24.2027 258.267 22.543 257.037 21.3189C255.807 20.0949 254.138 19.4064 252.398 19.4048Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M156.106 235.893C219.549 235.893 270.98 232.684 270.98 228.726C270.98 224.767 219.549 221.559 156.106 221.559C92.6624 221.559 41.2315 224.767 41.2315 228.726C41.2315 232.684 92.6624 235.893 156.106 235.893Z",
    fill: "url(#paint10_radial_10115_8881)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M231.04 229.441C260.623 229.441 284.606 227.945 284.606 226.099C284.606 224.254 260.623 222.758 231.04 222.758C201.456 222.758 177.474 224.254 177.474 226.099C177.474 227.945 201.456 229.441 231.04 229.441Z",
    fill: "url(#paint11_radial_10115_8881)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M81.1717 229.441C110.755 229.441 134.738 227.945 134.738 226.099C134.738 224.254 110.755 222.758 81.1717 222.758C51.588 222.758 27.6057 224.254 27.6057 226.099C27.6057 227.945 51.588 229.441 81.1717 229.441Z",
    fill: "url(#paint12_radial_10115_8881)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10115_8881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.083 163H69.9974C68.6741 163 67.405 162.664 66.4691 162.066C65.5333 161.467 65.0074 160.656 65.0071 159.809V151.191C65.0071 150.345 65.5328 149.533 66.4687 148.935C67.4046 148.336 68.6739 148 69.9974 148H234.083C235.407 148 236.676 148.336 237.612 148.935C238.547 149.533 239.073 150.345 239.073 151.191V159.809C239.073 160.656 238.547 161.467 237.611 162.065C236.676 162.664 235.407 163 234.083 163Z",
    fill: "#FFCA02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.004 163H234.083C235.406 163 236.675 162.664 237.611 162.065C238.547 161.467 239.072 160.656 239.072 159.809V151.191C239.073 150.345 238.547 149.533 237.611 148.935C236.676 148.336 235.407 148 234.083 148H242.004C242.66 148 243.308 148.083 243.914 148.243C244.519 148.403 245.069 148.638 245.533 148.935C245.996 149.231 246.363 149.583 246.614 149.97C246.865 150.357 246.994 150.772 246.994 151.191V159.809C246.994 160.656 246.468 161.467 245.532 162.065C244.597 162.664 243.328 163 242.004 163H242.004Z",
    fill: "#EFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.093 156.282H141.556L143.494 158.108L145.657 160.146H154.093C154.894 160.146 155.663 159.943 156.229 159.58C156.796 159.218 157.115 158.727 157.115 158.214C157.115 157.701 156.796 157.21 156.229 156.848C155.663 156.485 154.894 156.282 154.093 156.282ZM121.414 156.282H101.109L105.21 160.146H125.514L122.658 157.455L121.413 156.282M80.9658 156.282H77.0397C76.2382 156.282 75.4696 156.485 74.9029 156.848C74.3362 157.21 74.0178 157.701 74.0178 158.214C74.0178 158.727 74.3362 159.218 74.9029 159.58C75.4696 159.943 76.2382 160.146 77.0397 160.146H85.0696L82.2119 157.455L80.9673 156.282",
    fill: "#FFE328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.306 156.282H183.388C182.969 156.281 182.556 156.337 182.173 156.444L182.563 156.812L186.103 160.146H206.407L204.243 158.107L202.306 156.281",
    fill: "#FFE328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.516 148H213.658L229.577 163H209.435L193.516 148Z",
    fill: "#474337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.071 148H173.212L189.131 163H168.99L153.071 148Z",
    fill: "#474337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.306 156.281L204.243 158.107L202.306 156.281Z",
    fill: "#FFE63B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.202 156.282H202.306L204.243 158.108L206.407 160.146H220.202C221.004 160.146 221.772 159.943 222.339 159.58C222.906 159.218 223.224 158.727 223.224 158.214C223.224 157.701 222.906 157.21 222.339 156.848C221.772 156.485 221.004 156.282 220.202 156.282Z",
    fill: "#5C5849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.174 156.445C181.539 156.623 181.018 156.935 180.701 157.33C180.383 157.724 180.287 158.177 180.429 158.611C180.572 159.045 180.944 159.435 181.482 159.714C182.021 159.994 182.694 160.147 183.388 160.146H186.103L182.563 156.813L182.173 156.445",
    fill: "#5C5849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.624 148H132.765L148.685 163H128.544L112.624 148Z",
    fill: "#474337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.554 156.282H121.413L122.658 157.455L125.515 160.146H145.656L143.493 158.108L141.554 156.282Z",
    fill: "#5C5849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1785 148H92.3196L108.238 163H88.0972L72.1785 148Z",
    fill: "#474337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.108 156.282H80.9666L82.2112 157.455L85.0689 160.146H105.21L101.108 156.282Z",
    fill: "#5C5849"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10115_8881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.73 196.669C46.583 196.186 46.2844 195.764 45.8784 195.463C45.4723 195.163 44.9803 195.001 44.4749 195.001H39.5246C39.0193 195.001 38.5274 195.163 38.1214 195.464C37.7155 195.764 37.417 196.186 37.27 196.669L28.1791 226.505H55.8204L46.7298 196.669",
    fill: "#F8812F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7503 226.505H25.2495C24.9181 226.505 24.6003 226.637 24.366 226.87C24.1316 227.104 24 227.421 24 227.752C24 228.083 24.1316 228.4 24.366 228.633C24.6003 228.867 24.9181 228.998 25.2495 228.998H58.7503C59.0817 228.998 59.3995 228.867 59.6338 228.633C59.8682 228.4 59.9998 228.083 59.9998 227.752C59.9998 227.421 59.8682 227.104 59.6338 226.87C59.3995 226.637 59.0817 226.505 58.7503 226.505Z",
    fill: "#F4690B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7632 228.999H58.7504C59.0817 228.999 59.3995 228.868 59.6339 228.634C59.8682 228.4 59.9999 228.083 60 227.752C59.9999 228.081 59.8699 228.396 59.6384 228.629C59.4068 228.863 59.0923 228.995 58.7632 228.999Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7504 228.998H48.205C48.5364 228.997 48.8535 228.864 49.0867 228.629C49.3198 228.394 49.4498 228.076 49.4481 227.746C49.4464 227.415 49.3131 227.099 49.0776 226.866C48.8421 226.633 48.5236 226.504 48.1922 226.505H58.7504C59.0817 226.505 59.3996 226.637 59.6339 226.87C59.8682 227.104 59.9998 227.421 59.9998 227.752C59.9998 228.083 59.8682 228.4 59.6339 228.633C59.3996 228.867 59.0817 228.998 58.7504 228.998Z",
    fill: "#F04E06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8206 226.505L53.9713 220.437L53.5066 218.911L55.8206 226.505Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8206 226.505H47.9352L47.1409 220.437H53.9713L55.8206 226.505Z",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.575 209.288L50.1619 207.933L50.575 209.288Z",
    fill: "#82613F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8805 213.574L50.575 209.29V209.289L51.8805 213.574Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8805 213.573H46.243L45.5049 207.933H50.1618L50.575 209.288V209.289L51.8805 213.573Z",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6596 206.284L48.0707 201.07L47.423 198.944L49.6596 206.284Z",
    fill: "#82613F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0707 201.07H44.6072L44.0314 196.669C43.9011 195.678 43.5083 195.001 43.0637 195.001H44.4758C44.9811 195.002 45.4731 195.164 45.8791 195.464C46.2851 195.764 46.5837 196.186 46.7309 196.669L47.424 198.944L48.0716 201.07",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8114 210.715C37.7576 210.715 37.7038 210.712 37.6506 210.704C37.3633 210.662 37.1046 210.507 36.9313 210.275C36.758 210.042 36.6843 209.751 36.7264 209.464L36.9518 207.933H39.166L38.8941 209.781C38.856 210.041 38.7258 210.278 38.5272 210.449C38.3287 210.62 38.0749 210.715 37.8123 210.715M40.1758 201.07H37.9612L38.1825 199.57C38.2247 199.283 38.3793 199.025 38.6124 198.852C38.8454 198.679 39.1377 198.606 39.425 198.648C39.7124 198.69 39.9712 198.844 40.1445 199.077C40.3178 199.309 40.3914 199.601 40.3492 199.888L40.175 201.07",
    fill: "#FCA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9615 223.289C35.9077 223.289 35.854 223.285 35.8007 223.277C35.6585 223.256 35.5217 223.208 35.3983 223.134C35.2748 223.061 35.1671 222.963 35.0813 222.848C34.9955 222.733 34.9332 222.602 34.8981 222.463C34.863 222.324 34.8557 222.179 34.8766 222.038L35.1122 220.437H37.3254L37.0433 222.355C37.0053 222.614 36.8751 222.851 36.6765 223.022C36.4779 223.194 36.2242 223.288 35.9615 223.289Z",
    fill: "#FCA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8381 207.933H50.1618L48.0706 201.07H35.929L33.8381 207.933Z",
    fill: "#E2DED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0283 220.437H53.9713L51.8805 213.574H32.1195L30.0283 220.437Z",
    fill: "#E2DED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1619 207.933H45.5049L44.6072 201.07H48.0707L50.1619 207.933Z",
    fill: "#BAB6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9713 220.437H47.1409L46.243 213.574H51.8805L53.9713 220.437Z",
    fill: "#BAB6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1651 207.933H36.9518L37.9612 201.07H40.175L39.1651 207.933Z",
    fill: "#EFEDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3255 220.436H35.1122L35.7388 216.178C35.7769 215.918 35.9071 215.681 36.1058 215.51C36.3044 215.338 36.5583 215.244 36.8209 215.244C36.8745 215.244 36.9281 215.247 36.9812 215.255C37.2684 215.297 37.5271 215.452 37.7004 215.684C37.8737 215.916 37.9474 216.208 37.9053 216.495L37.3255 220.436Z",
    fill: "#EFEDE3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10115_8881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.73 196.669C273.583 196.186 273.284 195.764 272.878 195.463C272.472 195.163 271.98 195.001 271.475 195.001H266.525C266.019 195.001 265.527 195.163 265.121 195.464C264.715 195.764 264.417 196.186 264.27 196.669L255.179 226.505H282.82L273.73 196.669",
    fill: "#F8812F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75 226.505H252.249C251.918 226.505 251.6 226.637 251.366 226.87C251.132 227.104 251 227.421 251 227.752C251 228.083 251.132 228.4 251.366 228.633C251.6 228.867 251.918 228.998 252.249 228.998H285.75C286.082 228.998 286.4 228.867 286.634 228.633C286.868 228.4 287 228.083 287 227.752C287 227.421 286.868 227.104 286.634 226.87C286.4 226.637 286.082 226.505 285.75 226.505Z",
    fill: "#F4690B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.763 228.999H285.75C286.082 228.999 286.4 228.868 286.634 228.634C286.868 228.4 287 228.083 287 227.752C287 228.081 286.87 228.396 286.638 228.629C286.407 228.863 286.092 228.995 285.763 228.999Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75 228.998H275.205C275.536 228.997 275.854 228.864 276.087 228.629C276.32 228.394 276.45 228.076 276.448 227.746C276.446 227.415 276.313 227.099 276.078 226.866C275.842 226.633 275.524 226.504 275.192 226.505H285.75C286.082 226.505 286.4 226.637 286.634 226.87C286.868 227.104 287 227.421 287 227.752C287 228.083 286.868 228.4 286.634 228.633C286.4 228.867 286.082 228.998 285.75 228.998Z",
    fill: "#F04E06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.821 226.505L280.971 220.437L280.507 218.911L282.821 226.505Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.821 226.505H274.935L274.141 220.437H280.971L282.821 226.505Z",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.575 209.288L277.162 207.933L277.575 209.288Z",
    fill: "#82613F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.88 213.574L277.575 209.29V209.289L278.88 213.574Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.88 213.573H273.243L272.505 207.933H277.162L277.575 209.288V209.289L278.88 213.573Z",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.66 206.284L275.071 201.07L274.423 198.944L276.66 206.284Z",
    fill: "#82613F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.071 201.07H271.607L271.031 196.669C270.901 195.678 270.508 195.001 270.064 195.001H271.476C271.981 195.002 272.473 195.164 272.879 195.464C273.285 195.764 273.584 196.186 273.731 196.669L274.424 198.944L275.072 201.07",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.811 210.715C264.758 210.715 264.704 210.712 264.651 210.704C264.363 210.662 264.105 210.507 263.931 210.275C263.758 210.042 263.684 209.751 263.726 209.464L263.952 207.933H266.166L265.894 209.781C265.856 210.041 265.726 210.278 265.527 210.449C265.329 210.62 265.075 210.715 264.812 210.715M267.176 201.07H264.961L265.182 199.57C265.225 199.283 265.379 199.025 265.612 198.852C265.845 198.679 266.138 198.606 266.425 198.648C266.712 198.69 266.971 198.844 267.144 199.077C267.318 199.309 267.391 199.601 267.349 199.888L267.175 201.07",
    fill: "#FCA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.962 223.289C262.908 223.289 262.854 223.285 262.801 223.277C262.658 223.256 262.522 223.208 262.398 223.134C262.275 223.061 262.167 222.963 262.081 222.848C261.995 222.733 261.933 222.602 261.898 222.463C261.863 222.324 261.856 222.179 261.877 222.038L262.112 220.437H264.325L264.043 222.355C264.005 222.614 263.875 222.851 263.677 223.022C263.478 223.194 263.224 223.288 262.962 223.289Z",
    fill: "#FCA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.838 207.933H277.162L275.071 201.07H262.929L260.838 207.933Z",
    fill: "#E2DED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.028 220.437H280.971L278.88 213.574H259.12L257.028 220.437Z",
    fill: "#E2DED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.162 207.933H272.505L271.607 201.07H275.071L277.162 207.933Z",
    fill: "#BAB6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.971 220.437H274.141L273.243 213.574H278.88L280.971 220.437Z",
    fill: "#BAB6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.165 207.933H263.952L264.961 201.07H267.175L266.165 207.933Z",
    fill: "#EFEDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.325 220.436H262.112L262.739 216.178C262.777 215.918 262.907 215.681 263.106 215.51C263.304 215.338 263.558 215.244 263.821 215.244C263.875 215.244 263.928 215.247 263.981 215.255C264.268 215.297 264.527 215.452 264.7 215.684C264.874 215.916 264.947 216.208 264.905 216.495L264.325 220.436Z",
    fill: "#EFEDE3"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.772 66H108.336L103.62 50.772H103.548L98.7963 66H93.3963L86.0163 42.096H91.6323L96.3123 58.044H96.3843L101.352 42.096H105.924L110.892 58.152H110.964L115.68 42.096H121.152L113.772 66ZM138.536 58.728H125.936C126.44 61.032 128.528 62.292 131.444 62.292C133.892 62.292 135.98 61.572 137.348 60.24H137.528V64.776C136.124 65.784 133.856 66.36 131.228 66.36C125.252 66.36 121.184 62.76 121.184 57.54C121.184 52.356 124.856 48.72 130.004 48.72C135.26 48.72 138.536 51.852 138.536 56.82V58.728ZM130.148 52.788C128.132 52.788 126.404 53.904 125.936 55.884H134.288C133.964 53.832 132.38 52.788 130.148 52.788ZM157.893 48.72C160.233 48.72 161.853 49.116 163.149 49.98V55.02H162.969C161.853 53.58 160.341 52.896 158.397 52.896C155.301 52.896 153.429 54.696 153.429 57.54C153.429 60.348 155.301 62.184 158.397 62.184C160.377 62.184 161.889 61.464 162.969 60.024H163.149V65.1C161.925 65.964 160.269 66.36 157.893 66.36C152.385 66.36 148.677 62.724 148.677 57.54C148.677 52.356 152.385 48.72 157.893 48.72ZM183.726 66H179.802L179.658 63.732H179.586C178.47 65.388 176.598 66.36 174.078 66.36C169.29 66.36 165.798 62.652 165.798 57.54C165.798 52.428 169.29 48.72 174.078 48.72C176.562 48.72 178.47 49.656 179.55 51.276H179.622L179.802 49.08H183.726V66ZM174.87 62.184C177.39 62.184 179.154 60.276 179.154 57.54C179.154 54.804 177.39 52.896 174.87 52.896C172.314 52.896 170.55 54.804 170.55 57.54C170.55 60.276 172.314 62.184 174.87 62.184ZM197.367 48.72C201.507 48.72 203.955 51.384 203.955 55.956V66H199.239V56.532C199.239 54.192 198.087 52.896 196.107 52.896C193.911 52.896 192.615 54.372 192.615 57V66H187.899V49.08H191.823L192.003 51.492H192.075C193.083 49.728 194.919 48.72 197.367 48.72ZM206.501 51.132L209.813 42.096H214.673L210.317 51.132H206.501ZM227.421 61.212V65.784C226.593 66.18 225.549 66.36 224.109 66.36C220.005 66.36 217.809 64.128 217.809 59.844V53.076H215.001V49.08H217.953L218.565 44.328H222.525V49.08H227.385V53.076H222.525V59.664C222.525 61.284 223.389 62.184 224.865 62.184C225.729 62.184 226.521 61.968 227.241 61.212H227.421ZM79.5324 79.944C81.2244 79.944 82.4484 81.132 82.4484 82.824C82.4484 84.552 81.2244 85.74 79.5324 85.74C77.8404 85.74 76.6164 84.552 76.6164 82.824C76.6164 81.132 77.8404 79.944 79.5324 79.944ZM77.1564 105V88.08H81.8724V105H77.1564ZM95.554 87.72C99.694 87.72 102.142 90.384 102.142 94.956V105H97.426V95.532C97.426 93.192 96.274 91.896 94.294 91.896C92.098 91.896 90.802 93.372 90.802 96V105H86.086V88.08H90.01L90.19 90.492H90.262C91.27 88.728 93.106 87.72 95.554 87.72ZM112.284 87.72C114.336 87.72 116.28 88.116 117.612 88.8V93.3H117.432C116.316 92.184 114.588 91.608 112.392 91.608C110.556 91.608 109.656 92.148 109.656 93.192C109.656 93.948 110.232 94.272 112.464 94.416C116.964 94.704 118.728 96.288 118.728 99.852C118.728 103.308 116.136 105.36 111.78 105.36C108.972 105.36 106.812 104.856 105.372 103.848V99.312H105.588C106.92 100.752 108.936 101.472 111.564 101.472C113.4 101.472 114.3 100.932 114.3 99.852C114.3 98.952 113.58 98.592 111.204 98.376C106.92 97.98 105.228 96.684 105.228 93.336C105.228 89.916 108 87.72 112.284 87.72ZM137.466 105H133.542L133.362 102.588H133.29C132.282 104.352 130.482 105.36 128.034 105.36C123.894 105.36 121.446 102.66 121.446 98.088V88.08H126.162V97.548C126.162 99.888 127.314 101.184 129.294 101.184C131.454 101.184 132.75 99.708 132.75 97.08V88.08H137.466V105ZM150.885 87.72C151.965 87.72 152.865 87.972 153.369 88.368V92.976H153.189C152.469 92.472 151.569 92.184 150.525 92.184C147.645 92.184 146.349 93.948 146.349 97.728V105H141.633V88.08H145.557L145.773 90.708H145.845C146.781 88.728 148.437 87.72 150.885 87.72ZM172.005 97.728H159.405C159.909 100.032 161.997 101.292 164.913 101.292C167.361 101.292 169.449 100.572 170.817 99.24H170.997V103.776C169.593 104.784 167.325 105.36 164.697 105.36C158.721 105.36 154.653 101.76 154.653 96.54C154.653 91.356 158.325 87.72 163.473 87.72C168.729 87.72 172.005 90.852 172.005 95.82V97.728ZM163.617 91.788C161.601 91.788 159.873 92.904 159.405 94.884H167.757C167.433 92.832 165.849 91.788 163.617 91.788ZM189.417 111.84H184.557L187.761 104.46L181.245 88.08H186.285L190.245 99.24H190.317L194.241 88.08H199.101L189.417 111.84ZM208.901 87.72C214.193 87.72 217.937 91.356 217.937 96.54C217.937 101.688 214.193 105.36 208.901 105.36C203.573 105.36 199.829 101.688 199.829 96.54C199.829 91.356 203.573 87.72 208.901 87.72ZM208.901 91.896C206.345 91.896 204.581 93.804 204.581 96.54C204.581 99.276 206.345 101.184 208.901 101.184C211.421 101.184 213.185 99.276 213.185 96.54C213.185 93.804 211.421 91.896 208.901 91.896ZM236.852 105H232.928L232.748 102.588H232.676C231.668 104.352 229.868 105.36 227.42 105.36C223.28 105.36 220.832 102.66 220.832 98.088V88.08H225.548V97.548C225.548 99.888 226.7 101.184 228.68 101.184C230.84 101.184 232.136 99.708 232.136 97.08V88.08H236.852V105Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10115_8881",
    x1: 75.5082,
    y1: 116.925,
    x2: 86.8352,
    y2: 116.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10115_8881",
    x1: 72.387,
    y1: 200.799,
    x2: 90.1527,
    y2: 200.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10115_8881",
    x1: 72.387,
    y1: 171.583,
    x2: 90.1527,
    y2: 171.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10115_8881",
    x1: 81.1717,
    y1: 51.118,
    x2: 81.1717,
    y2: 43.0811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10115_8881",
    x1: 81.1686,
    y1: 209.079,
    x2: 81.1686,
    y2: 226.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10115_8881",
    x1: 225.376,
    y1: 116.925,
    x2: 236.703,
    y2: 116.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10115_8881",
    x1: 222.284,
    y1: 200.799,
    x2: 240.05,
    y2: 200.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10115_8881",
    x1: 222.284,
    y1: 171.583,
    x2: 240.05,
    y2: 171.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10115_8881",
    x1: 231.04,
    y1: 209.079,
    x2: 231.04,
    y2: 226.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10115_8881",
    x1: 231.04,
    y1: 51.118,
    x2: 231.04,
    y2: 43.0811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10115_8881",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.968 228.828) scale(114.876 7.17017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10115_8881",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.89 226.202) scale(53.5697 3.34365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10115_8881",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.0289 226.202) scale(53.5697 3.34365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10115_8881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 65 163)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10115_8881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white",
    transform: "translate(24 195)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10115_8881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white",
    transform: "translate(251 195)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectionRed);
export default __webpack_public_path__ + "static/media/rejection-red.fd2437dac424981dc9c6a9bbac379b59.svg";
export { ForwardRef as ReactComponent };